import socketIO from "socket.io-client";

export const io = socketIO(process.env.REACT_APP_SOCKET_URL, {
    withCredentials: true,
    transports: ["websocket"],
});
